import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHHorarioRangoDel = async (credentials, data) => {
  const body = {
    service: "RNHHorarioRangoDel",
    params: {
      rnhHorarioRangoId: data?.id ?? null,
      rnhHorarioRangoVersion: data?.version ?? null,
    },
  };
  return respuestaDe(await axiosPost(body, credentials));
};
